import { render, staticRenderFns } from "./not-found.vue?vue&type=template&id=565d89ac&lang=pug&"
import script from "./not-found.vue?vue&type=script&lang=js&"
export * from "./not-found.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('565d89ac')) {
      api.createRecord('565d89ac', component.options)
    } else {
      api.reload('565d89ac', component.options)
    }
    module.hot.accept("./not-found.vue?vue&type=template&id=565d89ac&lang=pug&", function () {
      api.rerender('565d89ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/errors/notFound/not-found.vue"
export default component.exports